import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { useTheme } from "../../../../contexts/ThemeContext";

export function DroppableList({ id, children, style }) {
  const { theme } = useTheme();
  const { isOver, setNodeRef } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      style={{
        border: isOver ? `1px dashed ${theme.primary}` : "1px dashed transparent",
        borderRadius: 8,
        minHeight: 8,
        ...style,
      }}
    >
      {children}
    </div>
  );
}